import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/productReview/importer/productReviewImporterActions'

export default importerReducers(actions)
